import { tw } from '@careinfo/tailwind';
import loadable from '@loadable/component';
import APIS from '../../constant/EndPoint';
import useUserServiceGetHook from '../../customHooks/useGetHook';
import usePostHook from '../../customHooks/usePostHook';
import CreateIcon from '../../Icons/CreateIcon';
import { patchApiData } from '../../helpers/AxiosInstance';
const CreateTicketComponent = loadable(
  () => import('../../components/Ticket/CreateTicket')
);

const CreateTicket = () => {
  const { data: profile } = useUserServiceGetHook({
    queryKey: [`profile`],
    url: `${APIS.USER}me/`,
    params: {},
  });

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ['ticket'],
    navigateURL: '/',
  });

  const handleCreate = async (values: any, setError: any) => {
    const url = `${APIS.TICKET}`;
    // const { extra_data, ...restValues } = values;
    let formData = {
      ...values,
      title: profile?.name,
      branch: profile?.default_branch?.id,
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      // if (res?.status === 201) {
      //   await patchApiData({
      //     url: `${APIS.TICKET_QUEUE}${values?.queue}/`,
      //     formData: { extra_data: extra_data },
      //     setError,
      //   });
      // }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Create Ticket
        </span>
      </div>
      <CreateTicketComponent
        isLoading={isPostLoading}
        handleCreate={handleCreate}
      />
    </>
  );
};

export default CreateTicket;
